// Primary
export const TEAL = 'TEAL';

// Dark to White
export const DARK = 'DARK';
export const DARK_NIGHT = 'DARK_NIGHT';
export const NIGHT = 'NIGHT';
export const EVENING = 'EVENING';
export const MEDIUM_GRAY = 'MEDIUM_GRAY';
export const WARM_LIGHT = 'WARM_LIGHT';
export const COOL_LIGHT = 'COOL_LIGHT';
export const SILK_WHITE = 'SILK_WHITE';
export const WHITE = 'WHITE';

// Arsenic
export const ARSENIC = 'ARSENIC';

// Secondary
export const CREATIVE = 'CREATIVE';
export const AUTHENTIC = 'AUTHENTIC';
export const SUMMER_GREEN = 'SUMMER_GREEN';
export const ENERGY = 'ENERGY';
export const DARK_ENERGY = 'DARK_ENERGY';
export const DEEP_ENERGY = 'DEEP_ENERGY';
export const DARK_TEAL = 'DARK_TEAL';
export const DEEP_TEAL = 'DEEP_TEAL';
export const ORAGNE = 'ORANGE';
export const ORCHID = 'ORCHID';
export const RED_VIOLET = 'RED_VIOLET';

// Pastel
export const BABY_TEAL = 'BABY_TEAL';
export const BABY_PEACH = 'BABY_PEACH';
export const LILAC = 'LILAC';
export const LIGHT_IVORY = 'LIGHT_IVORY';
export const BASE = 'BASE';

// Title and Body Colors
export const TITLE = 'TITLE';
export const BODY = 'BODY';

/** New Secondary Colors */

// Red Spectrum
export const MAGENTA = 'MAGENTA';
export const CARROT = 'CARROT';
export const ERROR_RED = 'ERROR_RED';
export const STRAWBERRY = 'STRAWBERRY';
export const YAM = 'YAM';

export const PENDING_YELLOW = 'PENDING_YELLOW';
export const MEDALLION = 'MEDALLION';
export const MUSTARD = 'MUSTARD';
export const SERENADE = 'SERENADE';

// Green Spectrum

export const CROCODILE = 'CROCODILE';
export const SUCCESS_GREEN = 'SUCCESS_GREEN';
export const OLIVE = 'OLIVE';
export const SAGE = 'SAGE';
export const AQUA_SPRING = 'AQUA_SPRING';

// Blue Specturm

export const HOKI = 'HOKI';
export const NEPTUNE = 'NEPTUNE';
export const AZURE = 'AZURE';
export const ECHO_BLUE = 'ECHO_BLUE';

export const MAUVE = 'MAUVE';
export const FIG = 'FIG';

export const DEPOSIT = 'DEPOSIT';
export const CLEARING = 'CLEARING';
export const LOAN_REVOLVING = 'LOAN_REVOLVING';
export const CUSTODY = 'CUSTODY';

// Neutral
export const PLACEHOLDER_GRAY = 'PLACEHOLDER_GRAY';
export const SEPARATOR_GRAY = 'SEPARATOR_GRAY';
export const FIELD_WHITE = 'FIELD_WHITE';
export const BTN_BACK = 'BTN_BACK';

export default {
  // Primary
  [TEAL]: '#049cb0',
  // Dark to White
  [DARK]: '#262626',
  [DARK_NIGHT]: '#333333',
  [NIGHT]: '#494949',
  [EVENING]: '#666666',
  [MEDIUM_GRAY]: '#8c8c8c',
  [WARM_LIGHT]: '#cccccc',
  [COOL_LIGHT]: '#e4e4e4',
  [SILK_WHITE]: '#f9f9f9',
  [WHITE]: '#ffffff',
  // Arsenic
  [ARSENIC]: '#364149',
  // Secondary
  [CREATIVE]: '#fdbd39',
  [AUTHENTIC]: '#8cc478',
  [SUMMER_GREEN]: '#2d9b00',
  [ENERGY]: '#cf5938',
  [DARK_ENERGY]: '#ae361f',
  [DEEP_ENERGY]: '#912f1c',
  [DARK_TEAL]: '#1c8290',
  [DEEP_TEAL]: '#166a75',
  [ORAGNE]: '#eb8a3b',
  [ORCHID]: '#a35e80',
  [RED_VIOLET]: '#7e4963',
  // Pastel
  [BABY_TEAL]: '#d1e2e5',
  [BABY_PEACH]: '#efdfd9',
  [LILAC]: '#ede2ef',
  [LIGHT_IVORY]: '#fdf8f3',
  [BASE]: '#DEE0D3',

  // Title And Body Color
  [TITLE]: '#1a1a1a',
  [BODY]: '#404040',

  /** New Secondary Colors */

  [MAGENTA]: '#975959',
  [CARROT]: '#D78040',
  [ERROR_RED]: '#DB6A4B',
  [STRAWBERRY]: '#C97660',
  [YAM]: '#D79864',

  [PENDING_YELLOW]: '#B18B3C',
  [MEDALLION]: '#CAA75F',
  [MUSTARD]: '#E7C06F',
  [SERENADE]: '#FAE4D4',

  [CROCODILE]: '#5B775B',
  [SUCCESS_GREEN]: '#A5BD83',
  [OLIVE]: '#A5AE7F',
  [SAGE]: '#B7BCB0',
  [AQUA_SPRING]: '#E4EBE4',

  [HOKI]: '#608085',
  [NEPTUNE]: '#79A9AF',
  [AZURE]: '#F2F7F7',
  [ECHO_BLUE]: '#9FB4DE',

  [MAUVE]: '#B59FA9',
  [FIG]: '#957484',

  [DEPOSIT]: '#7fadb2',
  [CLEARING]: '#c3acb7',
  [LOAN_REVOLVING]: '#6b9963',
  [CUSTODY]: '#c1d9ed',

  [FIELD_WHITE]: '#f6f6f6',
  [PLACEHOLDER_GRAY]: '#B3B3B3',
  [SEPARATOR_GRAY]: '#D9D9D9',
  [BTN_BACK]: '#E7E7E7',
};
